<div class="tarefas-relatos-container">
  <ng-container *ngIf="tarefas.length > 0; else vazioMsg">
    <div
      *ngFor="let tarefa of tarefas"
      class="d-flex align-items-start bloco-tarefa"
      [ngClass]="{
        relato: tarefa.tipo === 'relato',
        concluida: tarefa.status === 3,
        excluida: tarefa.status === 4
      }"
    >
      <div class="flex-grow-1">
        <div class="d-flex align-items-center mb-2">
          <div
            class="data-tarefa text-start me-2"
            [ngClass]="{ 'text-muted': tarefa.status === 4 }"
          >
            <span class="dia">{{ tarefa.dia }}</span>
            <span class="mes">{{ tarefa.mes }}</span>
          </div>
          <div class="linha-topo">
            <span
              class="fw-bold"
              [ngClass]="{
                'text-muted': tarefa.status === 4,
                'text-dark': tarefa.status !== 4
              }"
            >
              {{ getStatusText(tarefa) }}
            </span>

            <span class="text-muted"> por {{ tarefa.autor }}</span>
          </div>
        </div>

        <div class="linha-hora-titulo d-flex align-items-center mb-1">
          <strong
            class="hora"
            [ngClass]="{ 'text-muted': tarefa.status === 4 }"
          >
            {{ tarefa.hora }}
          </strong>
          <span class="mx-2">-</span>
          <span
            class="titulo"
            [ngClass]="{ 'text-muted': tarefa.status === 4 }"
          >
            {{ tarefa.titulo }}
          </span>
        </div>

        <p
          class="descricao"
          [ngClass]="{ 'text-muted': tarefa.status === 4 }"
          *ngIf="tarefa.descricao"
        >
          {{ tarefa.descricao }}
        </p>

        <div class="d-flex gap-2">
          <ng-container *ngIf="tarefa.tipo === 'relato'; else tarefaEditBtn">
            <button
              class="btn"
              type="button"
              (click)="onEditarRelato(tarefa)"
              [disabled]="tarefa.status === 4"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-editar.png"
                alt=""
                title="Editar relato"
                width="24"
                height="24"
              />
            </button>
          </ng-container>
          <ng-template #tarefaEditBtn>
            <button
              class="btn"
              type="button"
              (click)="editarTarefa(tarefa)"
              [disabled]="tarefa.status === 4"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-editar.png"
                alt=""
                title="Editar tarefa"
                width="24"
                height="24"
              />
            </button>
          </ng-template>

          <ng-container *ngIf="tarefa.tipo === 'tarefa'">
            <button
              class="btn"
              type="button"
              (click)="concluirTarefa(tarefa)"
              [disabled]="tarefa.status === 4"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-marcar-concluída-24.png"
                title="Marcar como concluída"
                alt=""
                width="24"
                height="24"
              />
            </button>
          </ng-container>

          <ng-container *ngIf="tarefa.tipo === 'tarefa'; else relatoDeleteBtn">
            <button
              class="btn"
              type="button"
              (click)="onDeletarTarefa(tarefa)"
              [disabled]="tarefa.status === 4"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-deletar.png"
                alt=""
                title="Deletar tarefa"
                width="24"
                height="24"
              />
            </button>
          </ng-container>
          <ng-template #relatoDeleteBtn>
            <button
              class="btn"
              type="button"
              (click)="onDeletarRelato(tarefa)"
              [disabled]="tarefa.status === 4"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-deletar.png"
                alt=""
                title="Deletar relato"
                width="24"
                height="24"
              />
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #vazioMsg>
    <div class="tarefas-relatos-vazio-msg">
      <p>Comece adicionando uma tarefa ou relato para acompanhar esta obra!</p>
    </div>
  </ng-template>
</div>
